import { Routes } from '@angular/router';
import { LoginComponent } from './core/auth/pages/login/login.component';
import { ForgotPasswordComponent } from './core/auth/pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './core/auth/pages/reset-password/reset-password.component';

import { AppShellComponent } from './core/layout/app-shell/app-shell.component';
import { HomeComponent } from './features/dashboard/pages/home/home.component';
import { PartnersComponent } from './features/partners/pages/partners/partners.component';
import { ReportsComponent } from './features/reports/pages/reports/reports.component';
import { ServicesComponent } from './features/services/pages/services/services.component';
import { UsersComponent } from './features/users/pages/users/users.component';
import { UserProfileComponent } from './features/users/pages/user-profile/user-profile.component';
import { UserCreateComponent } from './features/users/pages/user-create/user-create.component';
import { AuditLogComponent } from './features/audit-log/pages/audit-log/audit-log.component';
import { InitialContactComponent } from './features/clients/pages/initial-contact/initial-contact.component';
import { ClientDetailComponent } from './features/clients/pages/client-detail/client-detail.component';
import { ClientCaseComponent } from './features/clients/pages/client-case/client-case.component';
import { ClientProfileComponent } from './features/clients/pages/client-profile/client-profile.component';

import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [guestGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [guestGuard],
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [guestGuard],
  },
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      { path: 'home', component: HomeComponent, data: { title: 'Home' } },
      {
        path: 'partners',
        component: PartnersComponent,
        canActivate: [roleGuard],
        data: {
          title: 'Partner Organizations',
          subtitle: 'Create and manage partner organizations and approved services.',
          roles: ['admin', 'dekalb'],
        },
      },
      {
        path: 'services',
        component: ServicesComponent,
        canActivate: [roleGuard],
        data: { title: 'Services', subtitle: 'View and update services used in case workflows.', roles: ['admin', 'dekalb'] },
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [roleGuard],
        data: { title: 'Users', subtitle: 'Manage user access, roles, and profile information', roles: ['admin'] },
      },
      {
        path: 'users/new',
        component: UserCreateComponent,
        canActivate: [roleGuard],
        data: { title: 'Create User', roles: ['admin'] },
      },
      {
        path: 'users/:id/profile',
        component: UserProfileComponent,
        canActivate: [roleGuard],
        data: { title: 'User Profile', roles: ['admin'] },
      },
      {
        path: 'audit-log',
        component: AuditLogComponent,
        canActivate: [roleGuard],
        data: { title: 'Audit Log', subtitle: 'Track system changes and administrative events.', roles: ['admin'] },
      },
      {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [roleGuard],
        data: { title: 'Reports', roles: ['admin', 'dekalb'] },
      },
      {
        path: 'reports/:reportSlug',
        component: ReportsComponent,
        canActivate: [roleGuard],
        data: { title: 'Report', roles: ['admin', 'dekalb'] },
      },

      
      { path: 'clients/initial-contact', component: InitialContactComponent, data: { title: 'Initial Contact' } },
      { path: 'clients/:id', component: ClientDetailComponent, data: { title: 'Client Details' } },
      { path: 'clients/:id/profile', component: ClientProfileComponent, data: { title: 'Client Profile' } },
      { path: 'clients/:id/case', component: ClientCaseComponent, data: { title: 'Create Case' } },
      { path: 'clients/:id/case/:case_id', component: ClientCaseComponent, data: { title: 'Case Details' } },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];